'use strict';

require('jquery');

/**
 * A convenient spinner component to select an amount of something
 * (e.g users...). It has two toggles. One "decrease" toggle to decrease the amount,
 * and one "increase" toggle to increase the amount. It also includes a real
 * input type="number" field, that is hidden visually by default, but still
 * visible for screen readers. A placeholder shows an icon, that represents the
 * item the amount is set for, and the amount. The icon and the amount are
 * separated with the &times; symbol. The placeholder and the input="number" are
 * initialized and kept in sync via javascript. By clicking on the placeholder,
 * the input type="number" field is revealed to set the number by entering the
 * amount in the field. By clicking again on the placeholder,
 * the input type="number" disappears.
 *
 * @type {Object}
 */
var amountSpinner = {

  /**
   * Initializes the amount spinners plugin.
   * @param  {Object} jQuery Under which element we want to
   *                                        track for events.
   */
  init: function init() {

    // It uses the jquery boilerplate to build the plugin.
    // https://github.com/jquery-boilerplate/jquery-boilerplate
    //
    // Scroll down to the Plugin init method to get to the business logic.
    //
    // It is then made possible to fire the plugin on an DOM element like this:
    // $(yourElementSelector).amountSpinner();

    ;(function ($, window, document, undefined) {

      // Create the defaults once
      var pluginName = "amountSpinner",
          defaults = {};

      // The actual plugin constructor
      function Plugin(element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
      }

      // Avoid Plugin.prototype conflicts
      $.extend(Plugin.prototype, {

        init: function init() {

          var self = this;
          var $amountSpinner = $(this.element);

          // A handy class to test for before trigger. If it's there yet do
          // not trigger the plugin again on the element.
          $amountSpinner.addClass('hasAmountSpinner');

          /**
           * Init the amount spinner values.
           */
          var $value = $amountSpinner.find('.amount-spinner__value');
          this.updateValuePlaceholder($value);

          /**
           * Tracks on change events on the input field and reflects them to the
           * amount placeholder.
           */
          $value.on('change', function () {
            var $valueElement = $(this);
            self.setValueToInputField($valueElement);
            self.updateValuePlaceholder($valueElement);
            $valueElement.trigger('amountUpdate', $valueElement.val());
          });

          /**
           * Tracks click events on spinner toggles in order to increase/decrease
           * the amount an reflect the changes to the input field.
           */
          $amountSpinner.find('[class$="toggle"]').on('click', function (event) {
            event.preventDefault();
            var $toggle = $(this);
            var $valueElement = $toggle.siblings('.amount-spinner__value');
            var oldValue = parseFloat($valueElement.val());
            var min = $valueElement.attr('min');
            var max = $valueElement.attr('max');
            // Decides if increase or decrease and validates the submitted amount.
            if ($toggle.attr('class').lastIndexOf('__increase') > 0) {
              if (!max || oldValue < parseFloat(max)) {
                $valueElement.val(oldValue + 1);
              }
            } else if ($toggle.attr('class').lastIndexOf('__decrease')) {
              if (!min || oldValue > parseFloat(min)) {
                $valueElement.val(oldValue - 1);
              }
            } else {
              $valueElement.val(parseFloat(min));
            }

            // Sets the amount.
            self.updateValuePlaceholder($valueElement);

            $valueElement.trigger('amountUpdate', $valueElement.val());
          });

          /**
           * Tracks click events on the placeholder in order to reveal or hide the
           * input field, which allows manual typing of the amount.
           */
          $amountSpinner.find('.amount-spinner__value-placeholder').on('click', function (event) {
            event.preventDefault();
            $(this).siblings('.amount-spinner__value').toggleClass('amount-spinner__value--hidden').focus();
          });
        },

        /**
         * Sets the value to the Amount Spinner input field.
         * @param {Object} $valueElement The jquery object holding the input field.
         */
        setValueToInputField: function setValueToInputField($valueElement) {
          var value = $valueElement.val();
          var min = $valueElement.attr('min');
          var max = $valueElement.attr('max');
          var hasMin = typeof min !== 'undefined';
          var hasMax = typeof max !== 'undefined';

          // In case the value does not match the expected range, we set it either to
          // its possible min if exists, or to 0.
          if (value.length === 0 || hasMin && value < parseFloat(min) || hasMax && value > parseFloat(max)) {
            value = hasMin ? parseFloat(min) : 0;
            $valueElement.val(value);
          }
        },

        /**
         * Sets the value to the Amount Spinner placeholder.
         * @param {Object} $valueElement The jquery object holding the input field.
         */
        updateValuePlaceholder: function updateValuePlaceholder($valueElement) {
          var value = $valueElement.val();
          var $valuePH = $valueElement.siblings('.amount-spinner__value-placeholder');
          var $valueIconPH = $valueElement.siblings('.amount-spinner__icon-placeholder');

          // If the placeholder exists, updates it.
          if ($valuePH.length > 0) {
            $valuePH.find('span').text(value);
            $valuePH.find('i').attr('class', $valueElement.attr('data-icon'));
          }
          // if it does not exist, inserts it.
          else {
              // This force the value validation at page load.
              this.setValueToInputField($valueElement);
              $valueElement.before('<span class="amount-spinner__value-placeholder"><i class="' + $valueElement.attr('data-icon') + '"></i>&nbsp;&times;&nbsp;<span>' + $valueElement.val() + '<span></span>');
            }

          // Blur placeholder input to allow to trigger some external library
          // (e.g. Ember.JS) to update binded elements.
          // (Do not use focus here as it makes the page jump on click!)
          $valueElement.blur();
        }
      });

      // A really lightweight plugin wrapper around the constructor,
      // preventing against multiple instantiations
      $.fn[pluginName] = function (options) {
        return this.each(function () {
          if (!$.data(this, "plugin_" + pluginName)) {
            $.data(this, "plugin_" + pluginName, new Plugin(this, options));
          }
        });
      };
    })(jQuery, window, document);
  }

};

$(function () {

  amountSpinner.init();
});